import * as StoryletActionTypes from 'actiontypes/storylet';
import StoryletService from 'services/StoryletService';

/** ----------------------------------------------------------------------------
 * RENAME QUALITY
 -----------------------------------------------------------------------------*/
export default renameQuality(new StoryletService());

export function renameQuality(service) {
  return stuff => async (dispatch) => {
    dispatch(renameQualityRequested());
    try {
      const { data } = await service.renameQuality(stuff);
      dispatch(renameQualitySuccess(data));
    } catch (error) {
      dispatch(renameQualityFailure(error));
    }
  };
}

const renameQualityRequested = () => ({
  type: StoryletActionTypes.RENAME_QUALITY_REQUESTED,
  isRenaming: true,
});

const renameQualitySuccess = data => ({
  type: StoryletActionTypes.RENAME_QUALITY_SUCCESS,
  isRenaming: false,
  payload: {
    rename: data.rename,
    phase: data.phase,
    endStorylet: data.endStorylet,
    messages: data.messages,
  },
});

const renameQualityFailure = (/* error */) => ({
  type: StoryletActionTypes.RENAME_QUALITY_FAILURE,
  isRenaming: false,
});